import { i18n } from '../../../i18n';

export type ManagePlayingCopy = {
  emptyHint: string;
  addLabel: string;
  playlistLabel: string;
};

/**
 * Operator-facing labels for What's on this display.
 * Empty → start showing something; already live → add or change.
 */
export function managePlayingCopy(hasAssignment: boolean): ManagePlayingCopy {
  if (hasAssignment) {
    return {
      emptyHint: '',
      addLabel: i18n.t('displays:manage.playing.addContent'),
      playlistLabel: i18n.t('displays:manage.playing.changePlaylist'),
    };
  }

  return {
    emptyHint: i18n.t('displays:manage.playing.emptyHint'),
    addLabel: i18n.t('displays:manage.playing.addContent'),
    playlistLabel: i18n.t('displays:manage.playing.choosePlaylist'),
  };
}
